var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftMoustache(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5114",
    "data-name": "Group 5114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.744,
    height: 34.114,
    viewBox: "0 0 84.744 34.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1646",
    "data-name": "Rectangle 1646",
    width: 84.744,
    height: 34.114,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5112",
    "data-name": "Group 5112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12026",
    "data-name": "Path 12026",
    d: "M55.59,14.517A8.418,8.418,0,0,0,58.313,22.6a10.539,10.539,0,0,0,8.437,2c6.177-.927,9.916-7.535,9.16-13.4C75.269,5.072,69.522.513,63.6.114c-5.958-.618-11.794,1.349-17,3.942-10.372,5.17-19.4,13.761-31.171,14.8-2.812.106-5.885.106-8.429-1.04a9.185,9.185,0,0,1-5.1-6.4C1.489,8.7,3.05,5.381,6.025,5.211A3.758,3.758,0,0,1,9.593,6.836a4.339,4.339,0,0,1,.024,4L9.983,11a4.877,4.877,0,0,0,.268-4.576A4.738,4.738,0,0,0,5.935,4.073a5.667,5.667,0,0,0-4.56,2.512A8.923,8.923,0,0,0,0,11.689c.211,3.788,2.829,6.689,5.82,8.486a11.542,11.542,0,0,0,2.617,1.065l2.382.423A23.47,23.47,0,0,0,15.665,22c6.649.008,12.509-3.032,17.744-5.828,5.259-2.918,10.071-6.153,15.013-8.5C53.249,5.219,58.3,3.406,63.239,3.821a10.147,10.147,0,0,1,9.542,7.771c.9,4.43-1.569,9.876-6.413,10.941a8.831,8.831,0,0,1-7.258-.894,7.524,7.524,0,0,1-3.121-7.047Z",
    transform: "translate(8.736 -0.002)",
    fill: "#feb616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12027",
    "data-name": "Path 12027",
    d: "M62.811,1.694c-12.1,2.634-21.8,10.908-33.22,14.8-5.617,2.048-11.973,2.585-17.581.406a13.59,13.59,0,0,1-6.356-6.023A7.24,7.24,0,0,1,6.4,2.612l-.309-.26C3.28,4.1,2.338,8.5,3.646,11.879a16.259,16.259,0,0,0,7.023,8.055c6.608,3.016,14.021,2.487,20.231.374a85.875,85.875,0,0,0,16.525-8.949A125.563,125.563,0,0,1,62.892,2.092Z",
    transform: "translate(-3.069 12.074)",
    fill: "#feb616"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMoustache);
export default __webpack_public_path__ + "static/media/leftMoustache.90e874e53e0e477a0304171829e53db4.svg";
export { ForwardRef as ReactComponent };